let api_endpoint = "http://localhost:8071/api/"
let file_host = "http://localhost/"
let app_host = "http://localhost:3000/"

if (window.location.hostname === "helit.djarv.com") {
  api_endpoint = "https://helit.djarv.com/api/"
  file_host = "https://helit.djarv.com/"
  app_host = "https://helit.djarv.com/"
}

export interface AppConfig {
  TOKEN_NAME: string
  API_ENDPOINT: string
  FILE_HOST: string
  APP_HOST: string
}

export const CONFIG: AppConfig = {
  TOKEN_NAME: "hel_token",
  API_ENDPOINT: api_endpoint,
  FILE_HOST: file_host,
  APP_HOST: app_host
}